<script lang="ts">
  import BaseScene from "@engine/BaseScene.svelte";

  export let onPickMinigame: (id: string) => void;
  export let onBack: () => void;

  const minigames = [
    { id: "ocean_match", title: "Ocean Match", desc: "Match 30 real sea creatures to their habitat.", available: true },
    { id: "coming_soon", title: "More minigames coming soon", desc: "New games are added regularly.", available: false }
  ];
</script>

<BaseScene sceneId="minigame-hub" ariaLabel="Minigame picker" onEscape={onBack}>
  <div class="hub">
    <h1>Choose a Minigame</h1>
    <div class="hub__grid">
      {#each minigames as g (g.id)}
        <button
          type="button"
          class="hub__tile"
          class:hub__tile--disabled={!g.available}
          disabled={!g.available}
          on:click={() => onPickMinigame(g.id)}
        >
          <strong>{g.title}</strong>
          <p>{g.desc}</p>
        </button>
      {/each}
    </div>
    <button type="button" class="hub__back" on:click={onBack}>Back</button>
  </div>
</BaseScene>

<style>
  .hub {
    max-width: 720px;
    margin: 0 auto;
    padding: 2rem 1rem;
    text-align: center;
  }
  .hub h1 {
    font-size: 2rem;
    color: var(--color-heading);
    margin-bottom: 2rem;
  }
  .hub__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;
  }
  .hub__tile {
    min-height: 120px;
    padding: 1rem;
    background: var(--color-surface);
    border: 2px solid var(--color-accent);
    border-radius: 0.5em;
    cursor: pointer;
    text-align: left;
  }
  .hub__tile strong {
    display: block;
    color: var(--color-heading);
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }
  .hub__tile p {
    color: var(--color-body);
    margin: 0;
  }
  .hub__tile--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .hub__tile:focus-visible {
    outline: 3px solid var(--focus-ring);
    outline-offset: 2px;
  }
  .hub__back {
    min-height: 44px;
    padding: 0.5em 1.5em;
    background: transparent;
    color: var(--color-body);
    border: 1px solid var(--color-divider);
    border-radius: 0.5em;
    cursor: pointer;
  }
</style>
